export default __webpack_public_path__ + "static/media/harvard.b1754ba2.jpg";